// extracted by mini-css-extract-plugin
module.exports = {"menuTitle":"Footer_menuTitle__Phjaq","socialIconsLink":"Footer_socialIconsLink__NtRZN"};